import React from 'react';
import Profile from './Profile';
import '../css/AboutUs.css';

const Faculty = () => {
    const heading = 'Meet the Team';
    const faculty = [
        {
            "name": 'Yen Faltado',
            "subject": 'School Directress',
            "email": 'yen_faltado@stcjmis.edu.ph'
        },
        {
            "name": 'Jun Faltado',
            "subject": 'Owner',
            "email": 'jun_faltado@stcjmis.edu.ph'
        },
        {
            "name": 'Eden Destacamento',
            "subject": 'Principal',
            "email": 'eden_destacamento@stcjmis.edu.ph'
        },
        {
            "name": "Carlos Manaloto",
            "subject": "Math Teacher",
            "email": "carlos_manaloto@stcjmis.edu.ph"
        },
        {
            "name": "Lara Gomez",
            "subject": "Science Teacher",
            "email": "lara_gomez@stcjmis.edu.ph"
        },
        {
            "name": "Mikko Reyes",
            "subject": "Physical Education Teacher",
            "email": "mikko_reyes@stcjmis.edu.ph"
        },
        {
            "name": "Angela Lim",
            "subject": "English Teacher",
            "email": "angela_lim@stcjmis.edu.ph"
        },
        {
            "name": "Katrina Ponce",
            "subject": "Art Teacher",
            "email": "katrina_ponce@stcjmis.edu.ph"
        },
        {
            "name": "Joaquin Sison",
            "subject": "History Teacher",
            "email": "joaquin_sison@stcjmis.edu.ph"
        },
        {
            "name": "Paolo Villanueva",
            "subject": "Music Teacher",
            "email": "paolo_villanueva@stcjmis.edu.ph"
        },
        {
            "name": "Trina Santos",
            "subject": "Guidance Counselor",
            "email": "trina_santos@stcjmis.edu.ph"
        },
        {
            "name": "Marvin Cruz",
            "subject": "ICT Teacher",
            "email": "marvin_cruz@stcjmis.edu.ph"
        },
        {
            "name": "Jasmine Valdez",
            "subject": "Filipino Teacher",
            "email": "jasmine_valdez@stcjmis.edu.ph"
        },
        {
            "name": "Emman dela Cruz",
            "subject": "Social Studies Teacher",
            "email": "emman_delacruz@stcjmis.edu.ph"
        },
        {
            "name": "Rica Gonzales",
            "subject": "Home Economics Teacher",
            "email": "rica_gonzales@stcjmis.edu.ph"
        },
        {
            "name": "Neil Ramos",
            "subject": "Physics Teacher",
            "email": "neil_ramos@stcjmis.edu.ph"
        },
        {
            "name": "Sofia Bautista",
            "subject": "Chemistry Teacher",
            "email": "sofia_bautista@stcjmis.edu.ph"
        }
    ]

    return (
        <div className='faculty-container'>
            <div className='heading2 palanquin-dark bold primary-yellow-text flex-center'>
                {heading}
            </div>
            <div className='profile-component-container flex-center'>
                {faculty.map((member, index) => (
                    <Profile 
                        key={index} 
                        name={member.name} 
                        subject={member.subject} 
                        email={member.email} 
                    />
                ))}
            </div>
            
        </div>
    );
};

export default Faculty;
